<template>
  <div class="flex flex-col align-center h-full px-10">
    <h1 class="sm:text-3xl lg:text-4xl font-bold title-font text-default mb-4">Projets archivés</h1>
    <template v-if="loading">
      <div class="custom-skeleton p-4">
        <ul class="m-0 p-0">
          <li v-for="(_, key) in 3" :key="key" class="mb-10">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>

    <template v-else>
      <template v-if="trashedProjects.length">
        <div
          v-for="project in trashedProjects"
          :key="project.id"
          class="flex items-center justify-between p-3 border-dark border-t-2"
        >
          <div>
            <div class="flex items-center">
              <h2 class="inline mr-2" :class="`text-${project.color}`">{{ project.title }}</h2>
              <Chip :label="project.type" />
            </div>
            <p>{{ project.description || "Aucune description..." }}</p>
          </div>
          <div class="flex">
            <Button @click="restoreProject(project.id)" icon="mdi-undo" label="Restaurer" />
            <Button
              @click="deleteProject(project.id)"
              icon="mdi-delete"
              label="Supprimer"
              class="ml-5 btn-red"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="w-100 text-center mt-20">
          <v-mdi name="mdi-archive-alert-outline" class="w-24 h-24"></v-mdi>
          <p>Vous n'avez pas de projets archivés.</p>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Skeleton from "primevue/skeleton";

export default {
  name: "ProjectsArchive",
  components: {
    Skeleton,
  },
  data: () => ({
    loading: true,
    trashedProjects: [],
  }),
  async mounted() {
    await this.fetchTrashedProjects();
  },
  methods: {
    async fetchTrashedProjects() {
      this.loading = true;
      this.trashedProjects = (await axios.get("trashed-projects")).data;
      this.loading = false;
    },
    async restoreProject(idProject) {
      await axios.put("/trashed-projects/restore", {
        project_id: idProject,
      });

      this.$router.push("/dashboard");

      this.$toast.add({
        severity: "success",
        summary: "Projet restaurer",
        detail: "Le projet a été restauré avec succès",
        life: 3000,
      });
    },
    async deleteProject(idProject) {
      this.$confirm.require({
        message:
          "Êtes-vous sûr de vouloir définitivement supprimer ce projet ? Vous ne pourrez plus le restaurer par la suite.",
        header: "Confirmation de suppression",
        icon: "pi pi-exclamation-triangle",
		acceptLabel: 'Oui',
		rejectLabel: 'Non',
        accept: async () => {
          await axios.delete(`/projects/${idProject}`);

          this.trashedProjects = (await axios.get("trashed-projects")).data;

          this.$toast.add({
            severity: "success",
            summary: "Projet supprimé",
            detail: "Le projet a été supprimé avec succès",
            life: 3000,
          });
        },
      });
    },
  },
};
</script>
